import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getItemApi } from '../../../apiUtils';
import { useTranslation } from '../../../contexts/translation';
import { Asset } from '../../../types/asset.types';
import { Language } from '../../../types/language.types';
import { ParameterMeasurableLast } from '../../../types/parameter.types';
import { API_URL } from '../../../utils/apiUrl';
import {
  displayDateFormat_CZ,
  displayDateFormat_EN,
  displayDateTimeFormat_CZ,
  displayDateTimeFormat_EN,
} from '../../../utils/dates.types';

export interface Props {
  assetId: number;
}

export const ParametersMeasuringLast = ({ assetId }: Props) => {
  const transFormName = 'ParameterMeasuredMobile.Last';
  const { translate, lang } = useTranslation();

  const [lastMeasuredParameter, setLastMeasuredParameter] =
    useState<ParameterMeasurableLast | null>(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    getLastMeasuredParameter();
  }, []);

  const getLastMeasuredParameter = async () => {
    setLoading(true);
    await getItemApi<Asset>({
      url: `${API_URL.ASSET_PARAMETER_MEASURED_LAST_FOR_ASSET}`,
      params: {
        assetId: assetId,
      },
      callAfterSuccess: (result) => {
        setLastMeasuredParameter(result);
      },
    });
    setLoading(false);
  };

  const formatValue = () => {
    if (!lastMeasuredParameter) return <></>;

    let value: any = lastMeasuredParameter.value;
    let unitName: any = ` ${lastMeasuredParameter.unitName}`;

    if (
      lastMeasuredParameter.unitDataType === 'Float' ||
      lastMeasuredParameter.unitDataType === 'Int'
    )
      value = value.toLocaleString();

    if (lastMeasuredParameter.unitDataType === 'Date') {
      value = moment(value).format(
        lang === Language.CS ? displayDateFormat_CZ : displayDateFormat_EN,
      );
      unitName = '';
    }

    if (lastMeasuredParameter.unitDataType === 'DateTime') {
      value = moment(value).format(
        lang === Language.CS ? displayDateTimeFormat_CZ : displayDateTimeFormat_EN,
      );
      unitName = '';
    }

    if (lastMeasuredParameter.unitDataType === 'Bool') {
      value = value
        ? translate!('Boolean positive', transFormName)
        : translate!('Boolean negative', transFormName);
      unitName = '';
    }

    return (
      <>
        {value}
        {unitName}
      </>
    );
  };

  if (isLoading || !lastMeasuredParameter) return <></>;

  return (
    <div style={{ padding: 15 }}>
      <div style={{ fontSize: 20, marginBottom: 5, fontWeight: 'bold' }}>
        {translate!('Last measuring', transFormName)}:
      </div>
      <div style={{ fontSize: 20, color: '#6d6b6b' }}>
        {moment(lastMeasuredParameter.created).format(
          lang === Language.CS ? displayDateTimeFormat_CZ : displayDateTimeFormat_EN,
        )}
      </div>
      <div style={{ fontSize: 24 }}>
        {lastMeasuredParameter.assetParameterName}: {formatValue()}
      </div>
    </div>
  );
};
